import { render, staticRenderFns } from "./AssProdutoModal.vue?vue&type=template&id=67353beb&scoped=true"
import script from "./AssProdutoModal.vue?vue&type=script&lang=js"
export * from "./AssProdutoModal.vue?vue&type=script&lang=js"
import style0 from "./AssProdutoModal.vue?vue&type=style&index=0&id=67353beb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67353beb",
  null
  
)

export default component.exports